module.exports = __webpack_public_path__ + "img/credential12.a513d888.png";